/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Preference from './Preference/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/Patient/Emails/Email"
  
}) {
let editRelationEmailAddressValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation_email',
path: 'address',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let editRelationEmailDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation_email',
path: 'description',
})
let aggregateData = fromAggregate.getValueOrDefault(editRelationEmailDescriptionValueData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Email.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Email.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 data="edit_relation_email.address"
 text={editRelationEmailAddressValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingBottom={dtSpaceXxs}
 size="small"
 color={dtColorsNeutral500}
 data="edit_relation_email.description"
 aggregate="/Data/aggregate.js getValueOrDefault"
 text={aggregateData}
/>
</div>
<Preference
  viewPath={`${viewPath}/Preference`}
/>
</div>
{children}
</React.Fragment>)
}